export const getDefaultValues = (gameJoinDetails) => ({
  GameJoinApplicationGameID: gameJoinDetails?.GameID || '',
  GameJoinApplicationAmount: gameJoinDetails?.GameJoinApplicationAmount || '',
  GameJoinApplicationHasScoreBoard: gameJoinDetails?.GameJoinApplicationHasScoreBoard || '',
  GameJoinApplicationHasLeaderBoard: gameJoinDetails?.GameJoinApplicationHasLeaderBoard || '',
  GameJoinApplicationIsFree: gameJoinDetails?.GameJoinApplicationIsFree || '',
});
